const InstagramIcon = ({ color }: any) => {
  return (
    <svg width='30' height='30' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M0 0H30V30H0V0Z' fill='url(#paint0_linear)' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.8335 7.29175C8.87753 7.29175 7.29187 8.87741 7.29187 10.8334V19.1667C7.29187 21.1228 8.87753 22.7084 10.8335 22.7084H19.1669C21.1229 22.7084 22.7085 21.1228 22.7085 19.1667V10.8334C22.7085 8.87741 21.1229 7.29175 19.1669 7.29175H10.8335ZM6.04187 10.8334C6.04187 8.18705 8.18717 6.04175 10.8335 6.04175H19.1669C21.8132 6.04175 23.9585 8.18705 23.9585 10.8334V19.1667C23.9585 21.8131 21.8132 23.9584 19.1669 23.9584H10.8335C8.18717 23.9584 6.04187 21.8131 6.04187 19.1667V10.8334ZM15.4335 12.285C14.87 12.2014 14.2945 12.2976 13.7888 12.56C13.2832 12.8224 12.8732 13.2375 12.617 13.7464C12.3609 14.2552 12.2718 14.8318 12.3623 15.3943C12.4528 15.9567 12.7183 16.4763 13.1211 16.8791C13.5239 17.2819 14.0435 17.5474 14.6059 17.6379C15.1684 17.7284 15.745 17.6393 16.2539 17.3832C16.7627 17.1271 17.1778 16.717 17.4402 16.2114C17.7026 15.7057 17.7988 15.1302 17.7153 14.5667C17.63 13.9919 17.3622 13.4598 16.9513 13.0489C16.5404 12.638 16.0083 12.3702 15.4335 12.285ZM13.2131 11.4505C13.9521 11.067 14.7933 10.9264 15.6168 11.0485C16.4569 11.1731 17.2347 11.5645 17.8352 12.165C18.4357 12.7656 18.8272 13.5433 18.9517 14.3834C19.0739 15.207 18.9332 16.0481 18.5497 16.7871C18.1663 17.5261 17.5595 18.1254 16.8158 18.4997C16.0722 18.874 15.2294 19.0043 14.4074 18.8721C13.5853 18.7398 12.826 18.3517 12.2373 17.763C11.6485 17.1742 11.2604 16.4149 11.1282 15.5929C10.9959 14.7709 11.1262 13.9281 11.5005 13.1844C11.8748 12.4407 12.4741 11.834 13.2131 11.4505ZM19.5831 9.47925C19.0654 9.47925 18.6456 9.89898 18.6456 10.4167C18.6456 10.9345 19.0654 11.3542 19.5831 11.3542H19.5915C20.1092 11.3542 20.529 10.9345 20.529 10.4167C20.529 9.89898 20.1092 9.47925 19.5915 9.47925H19.5831Z'
        fill='white'
      />
      <defs>
        <linearGradient
          id='paint0_linear'
          x1='0.000175341'
          y1='32.1422'
          x2='34.2859'
          y2='-0.000655473'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFDD55' />
          <stop offset='0.526042' stopColor='#FF543E' />
          <stop offset='1' stopColor='#C837AB' />
        </linearGradient>
      </defs>
    </svg>
  )
}

export default InstagramIcon
